import { useSelector } from 'react-redux'

export default function useUserId(): number {
  return useSelector((state: any) => state.user.id)
}
